import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { AutoComplete, Tooltip } from "antd";
import Compact from "antd/es/space/Compact";
import React from "react";
import { CreateArticle } from "src/enitities/Form";
import debounce from "../lib/utils/debounce";

const COOKIE_KEY = "recentArticles";
const MAX_RECENT = 5;

const setRecentArticles = (articles) => {
  const expires = new Date(Date.now() + 365 * 86400000).toUTCString();
  document.cookie = `${COOKIE_KEY}=${encodeURIComponent(
    JSON.stringify(articles)
  )}; expires=${expires}; path=/`;
};

const getRecentArticles = () => {
  const match = document.cookie.match(new RegExp(`(^| )${COOKIE_KEY}=([^;]+)`));
  return match ? JSON.parse(decodeURIComponent(match[2])) : [];
};

const searchResult = async (api, token, query) => {
  return fetch(`${api}articles/?token=${token}&name=${query}`)
    .then((response) => response.json())
    .then((body) =>
      body.result.map((user) => ({
        label: (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>{user.name}</div>
            {user.dc && (
              <Tooltip
                title={
                  user.dc === "debit"
                    ? "Приход"
                    : user.dc === "credit"
                    ? "Расход"
                    : ""
                }
              >
                {user.dc === "debit" ? (
                  <ArrowDownOutlined style={{ color: "green" }} />
                ) : user.dc === "credit" ? (
                  <ArrowUpOutlined style={{ color: "red" }} />
                ) : (
                  ""
                )}
              </Tooltip>
            )}
          </div>
        ),
        value: user.id,
        raw: user,
      }))
    );
};

class ArticleAutocomplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      recentArticles: [],
    };
  }

  async componentDidMount() {
    const recent = getRecentArticles();
    const loadedRecent = await Promise.all(
      recent.map(async (entry) => {
        try {
          const article = await this.props.findArticle(entry.id);
          return article ? { ...article, timestamp: entry.timestamp } : null;
        } catch (e) {
          return null;
        }
      })
    );

    this.setState(
      {
        recentArticles: loadedRecent.filter(Boolean),
      },
      () => {
        this.handleSearch("");
      }
    );
  }

  handleSearch = async (value) => {
    const options = await searchResult(this.props.api, this.props.token, value);

    const { recentArticles } = this.state;
    const sortedRecent = [...recentArticles].sort(
      (a, b) => b.timestamp - a.timestamp
    );

    const recentOptions = sortedRecent.map((art) => ({
      label: (
        <div
          style={{
            fontWeight: "bold",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>{art.name}</div>
          {art.dc && (
            <Tooltip
              title={
                art.dc === "debit"
                  ? "Приход"
                  : art.dc === "credit"
                  ? "Расход"
                  : ""
              }
            >
              {art.dc === "debit" ? (
                <ArrowDownOutlined style={{ color: "green" }} />
              ) : art.dc === "credit" ? (
                <ArrowUpOutlined style={{ color: "red" }} />
              ) : (
                ""
              )}
            </Tooltip>
          )}
        </div>
      ),
      value: art.id,
    }));

    // удаляем дубликаты по ID
    const existingIds = new Set(recentOptions.map((o) => o.value));
    const filtered = options.filter((o) => !existingIds.has(o.value));

    this.setState({ options: [...recentOptions, ...filtered] });
  };

  searchHandler = debounce(this.handleSearch, 750);

  handleSelect = async (value, option) => {
    const recent = getRecentArticles();
    const updated = [
      { id: value, timestamp: Date.now() },
      ...recent.filter((item) => item.id !== value),
    ].slice(0, MAX_RECENT);

    setRecentArticles(updated);

    // обновим в state, чтобы отображались актуально
    try {
      const article = await this.props.findArticle(value);
      if (article) {
        this.setState(
          (prev) => ({
            recentArticles: [
              article,
              ...prev.recentArticles.filter((a) => a.id !== value),
            ].slice(0, MAX_RECENT),
          }),
          () => {
            this.handleSearch(""); // обновим options
          }
        );
      }
    } catch (e) {
      console.warn("Ошибка при обновлении списка последних статей", e);
    }

    if (this.props.onSelect) {
      this.props.onSelect(value, option);
    }
  };

  render() {
    const { options } = this.state;

    return (
      <Compact
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <AutoComplete
          {...this.props}
          options={options}
          onSearch={this.searchHandler}
          onSelect={this.handleSelect}
        />
        {this.props.withbutton && this.props.isnewarticle && (
          <CreateArticle
            token={this.props.token}
            handleSearch={this.handleSearch}
            onSelect={this.props.onSelect}
            newArticleName={this.props.newarticlename}
          />
        )}
      </Compact>
    );
  }
}

export default ArticleAutocomplete;
